import { ALL_COUNTRIES_WITH_USA_FIRST } from "$lib/util/country"
import { isValidTaxNumber } from "$lib/yup/personal-info/tax-information"
import {
  entityBeneficialOwnerSchema,
  nationalIdentificationSchema,
} from "@tastyworks/tastyworks-api/validate"
import type { Alpha3Code } from "i18n-iso-countries/index"
import { array, boolean, mixed, object, string, type InferType } from "yup"

export const trusteeNameSchema = entityBeneficialOwnerSchema.pick([
  "firstName",
  "middleName",
  "lastName",
])

export const trusteeDetailsSchema = entityBeneficialOwnerSchema.pick([
  "email",
  "birthDate",
])

export const trusteeTaxInfoSchema = object({
  citizenshipCountry: mixed<Alpha3Code>()
    .required()
    .oneOf(ALL_COUNTRIES_WITH_USA_FIRST),
  residesInUS: boolean().required(),
  taxNumber: string().when("residesInUS", {
    is: true,
    then: (schema) =>
      schema
        .transform((value) => value?.replaceAll("-", ""))
        .length(9)
        .test(
          "invalid-tax-number",
          "yup.common.taxInformation.invalidTaxNumber",
          isValidTaxNumber
        )
        .required(),
    otherwise: (schema) => schema.max(40).required(),
  }),
})

export const trusteeAddressSchema = entityBeneficialOwnerSchema.pick([
  "address",
])

export const trusteeIdentificationSchema = nationalIdentificationSchema

export const trusteeSchema = trusteeNameSchema
  .concat(trusteeDetailsSchema)
  .concat(trusteeTaxInfoSchema)
  .concat(object({ identification: trusteeIdentificationSchema }))
  .concat(trusteeAddressSchema)

export type TrusteeData = InferType<typeof trusteeSchema>

export const otherTrusteesSchema = object({
  hasOtherTrustees: boolean().required(),
})

export const trusteesTableSchema = object({
  shouldShowTrusteeForm: boolean().default(false),
  trustees: array().of(trusteeSchema).ensure(),
})

export const trusteeSectionSchema = object({
  otherTrustees: otherTrusteesSchema,
  trusteesTable: trusteesTableSchema,
  trusteeName: trusteeNameSchema,
  trusteeDetails: trusteeDetailsSchema,
  trusteeTaxInfo: trusteeTaxInfoSchema,
  trusteeIdentification: trusteeIdentificationSchema,
  trusteeAddress: trusteeAddressSchema,
})
